<template>
  <div tabindex="0" class="min-h-screen flex flex-col" :class="route.meta.theme ?? 'light'">
    <page-header />
    <main class="flex-grow">
      <div :class="{ 'container max-w-[1200px]': $router.currentRoute.value.name !== 'page-not-found' }">
        <router-view />
        <spinner-overlay />
      </div>
    </main>
    <page-footer />
  </div>
</template>

<script setup lang="ts">
import PageHeader from '@/components/layout/PageHeader.vue'
import SpinnerOverlay from '@/components/layout/SpinnerOverlay.vue'
import PageFooter from '@/components/layout/PageFooter.vue'
import { useAuthStore } from '@/stores/auth-store'
import { useRoute } from 'vue-router'
import { watch, onMounted } from 'vue'
import { useEcommerceTracking } from '@/composables/useEcommerceTracking'

const route = useRoute()
const authStore = useAuthStore()
const { trackUserId } = useEcommerceTracking()

onMounted(() => trackUserId(authStore.user.id))
watch(() => authStore.user.id, (newUserId) => trackUserId(newUserId))
</script>
